import { morphism } from 'morphism'

import tourOperatorSchema from '../../schemas/tourOperator'

import tourOperatorModel from '../../models/TourOperator'

import staticData from '../../config/staticData'

import callAPI from '../../utils/requests/callAPI'
import setAuthorizationHeader from '../../utils/requests/setAuthorizationHeader'
import {
  userCustomTourOperatoreCode,
  userHasCustomTourOperatorCode,
} from '../../utils/tourOperators'

import v1throwError from '../../actions/errors/v1throwError'
import { v1receiveFilteredTourOperators } from '../../actions/tourOperators'
import { V1_REQUEST_FILTERED_TOUR_OPERATORS } from '../../actions/tourOperators/v1requestFilteredTourOperators'

export default store => next => async action => {
  next(action)

  if (action.type !== V1_REQUEST_FILTERED_TOUR_OPERATORS) {
    return
  }

  const dispatch = store.dispatch

  try {
    const headers = new Headers(staticData.endpoints.allotments.headers)
    await setAuthorizationHeader(headers)
    const baseUrl = `${
      staticData.endpoints.allotments.url
    }seattrade/touroperators`
    const url = userHasCustomTourOperatorCode()
      ? `${baseUrl}?tourOperatorCode=${userCustomTourOperatoreCode()}`
      : baseUrl

    const data = await callAPI(url, {
      headers,
    })

    if (data.error) throw data.error

    const tourOperators = data.length ? data : []

    const formattedTourOperators = tourOperators.map(tourOperator => {
      return morphism(tourOperatorSchema, tourOperator, tourOperatorModel)
    })

    dispatch(v1receiveFilteredTourOperators(formattedTourOperators))
  } catch (error) {
    dispatch(v1throwError(error))
  }
}
